import { B2bIndividualOperationsList } from '@sh4res/bo-common/components/B2bIndividualOperations/B2bIndividualOperationsList';
import { B2bIndividualOperationsShow } from '@sh4res/bo-common/components/B2bIndividualOperations/B2bIndividualOperationsShow';

import { ResourceDefinition } from '@Utils/types';

export const individualOperationsResource: ResourceDefinition = {
  options: { label: 'menu.individual_operations' },
  list: (props) => (
    <B2bIndividualOperationsList testId="BoExternalB2bIndividualOperationsList" {...props} />
  ),
  show: B2bIndividualOperationsShow,
};
